import TREventsBlockReducer from './TREventsBlockReducer';

export const TREventsBlockReducers = {
  TREventsBlockReducer,
};
export default from './TREventsBlockContainer';
